module.exports = __webpack_public_path__ + "1e349351036e46cb943d416c43089c57.svg";